module.exports = __webpack_public_path__ + "img/swipe_img_5.6fb38313.png";